import { render } from "./Tabs.vue?vue&type=template&id=e07c6798&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=e07c6798&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-meter-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e07c6798"],['__file',"src/assets/js/components/Tabs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e07c6798"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e07c6798', __exports__)) {
    api.reload('e07c6798', __exports__)
  }
  
  module.hot.accept("./Tabs.vue?vue&type=template&id=e07c6798&scoped=true", () => {
    api.rerender('e07c6798', render)
  })

}


export default __exports__